(function () {
  'use strict';

  var downX = null, downY = null;

  document.addEventListener('pointerdown', function (e) {
    downX = e.clientX; downY = e.clientY;
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var btn = e.target.closest('.card-gallery__btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var g = btn.closest('.card-gallery');
      var t = g && g.querySelector('.card-gallery__track');
      if (!t) return;
      var dir = btn.getAttribute('data-dir') === 'next' ? 1 : -1;
      t.scrollBy({ left: dir * t.clientWidth, behavior: 'smooth' });
      return;
    }

    var gallery = e.target.closest('.card-gallery');
    if (!gallery) return;

    // ignore swipes, but only if a pointerdown was actually recorded
    if (downX !== null && (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8)) return;

    var link = gallery.querySelector('.card-gallery__link');
    if (link && link.href) window.location.href = link.href;
  });

  var pending = false;
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.classList) return;
    if (!track.classList.contains('card-gallery__track')) return;
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      var g = track.closest('.card-gallery');
      if (!g) return;
      var dots = g.querySelectorAll('.card-gallery__dot');
      if (!dots.length) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
    });
  }, true);
})();
/* ---- PDP main image arrows ---- */
(function () {
  function step(gal, delta) {
    var items = Array.prototype.slice.call(
      gal.querySelectorAll('.thumbnail-list__item')
    );
    if (items.length < 2) return;
    var idx = -1;
    for (var i = 0; i < items.length; i++) {
      var b = items[i].querySelector('button');
      if (b && b.getAttribute('aria-current') === 'true') { idx = i; break; }
    }
    if (idx < 0) idx = 0;
    var target = items[(idx + delta + items.length) % items.length]
      .querySelector('button');
    if (target) target.click();
  }

  function arrow(dir, gal) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pdp-arrow pdp-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'next' ? 'Next image' : 'Previous image');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
      'stroke-linejoin="round"><polyline points="' +
      (dir === 'next' ? '9 6 15 12 9 18' : '15 6 9 12 15 18') +
      '"/></svg>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      step(gal, dir === 'next' ? 1 : -1);
    });
    return b;
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gal) {
      if (gal.dataset.pdpArrows) return;
      if (gal.querySelectorAll('.thumbnail-list__item').length < 2) return;
      var list = gal.querySelector('.product__media-list');
      if (!list) return;

      gal.dataset.pdpArrows = '1';

      var wrap = document.createElement('div');
      wrap.className = 'pdp-media-wrap';
      list.parentNode.insertBefore(wrap, list);
      wrap.appendChild(list);
      wrap.appendChild(arrow('prev', gal));
      wrap.appendChild(arrow('next', gal));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();